import { Button } from "@/components/ui/button";
import { MessageSquare, Lightbulb, Info } from "lucide-react";
import { LevelSetQuestion } from "./questionTypes";

interface LevelSetScreenProps {
  question: LevelSetQuestion;
  onNext: () => void;
}

const iconMap: Record<string, React.ComponentType<{ className?: string }>> = {
  'chat': MessageSquare,
  'lightbulb': Lightbulb,
  'info': Info,
};

export function LevelSetScreen({ question, onNext }: LevelSetScreenProps) {
  return (
    <div className="max-w-2xl mx-auto w-full">
      <div className="space-y-4">
        {question.sections.map((section, index) => {
          const IconComponent = iconMap[section.icon as string] || Info;
          const displayTitle = section.title === "How it works" ? "How this assessment works" : section.title;

          return (
            <div
              key={index}
              className="border border-border rounded-lg p-5 flex gap-4"
            >
              {/* Icon circle */}
              <div className="flex-shrink-0">
                <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                  <IconComponent className="w-5 h-5 text-primary" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-sm text-foreground mb-1">
                  {displayTitle}
                </h3>
                <div className="text-[13px] text-muted-foreground leading-relaxed">
                  {section.content.split('\n').map((line, lineIndex) => {
                    if (line.startsWith('•')) {
                      return (
                        <div key={lineIndex} className="flex items-start gap-2 mt-1.5">
                          <span className="text-primary mt-0.5 flex-shrink-0">•</span>
                          <span>{line.substring(1).trim()}</span>
                        </div>
                      );
                    }
                    return (
                      <p key={lineIndex} className={lineIndex > 0 ? "mt-1.5" : ""}>
                        {line}
                      </p>
                    );
                  })}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <Button
        onClick={onNext}
        className="w-full mt-8 bg-primary hover:bg-primary/90 text-primary-foreground min-h-[48px] font-medium text-base"
      >
        {question.buttonText}
      </Button>
    </div>
  );
}
